import { DateCalendar } from "@mui/x-date-pickers";
import moment from "moment";
import { useState } from "react";
import { formatDate } from "../../utils/helpers";
import Dropdown from "../dropdown/dropdown";
import { CaretDown } from "../icon/downcaret";
import { TextInput } from "./textInput";

export const DateInput = ({
  placeholder = "",
  errors = "",
  title = "",
  date,
  minDate,
  referenceDate,
  setDate = () => {},
  onBlur,
  className = "",
  name,
}: {
  placeholder: string;
  name: string;
  errors?: string;
  title: string;
  date?: Date | null;
  minDate?: moment.Moment;
  referenceDate?: moment.Moment;
  onBlur: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  setDate?: (date: Date | null) => void;
  className?: string;
}) => {
  const [clicked, setClicked] = useState<boolean>(false);

  return (
    <Dropdown
      customMenuItems={
        <div className={className}>
          <DateCalendar
            value={clicked && date === null ? moment(new Date()) : moment(date)}
            onChange={(newDate) => {
              setDate(newDate);
            }}
            minDate={minDate}
            referenceDate={referenceDate}
            disablePast
            views={["year", "month", "day"]}
            sx={{
              "& .MuiPickersDay-root.Mui-selected": {
                backgroundColor: "#04000A !important",
                color: "white",
              },
              "& .MuiPickersMonth-monthButton.Mui-selected": {
                backgroundColor: "#04000A !important",
                color: "white",
              },
              "& .MuiPickersYear-yearButton.Mui-selected": {
                backgroundColor: "#04000A !important",
                color: "white",
              },
            }}
          />
        </div>
      }
      menuClassName="rounded-xl bg-white !shadow-sm border"
      closeOnClick={false}
      className={`w-full`}
      position="bottom"
    >
      <TextInput
        type="text"
        name={name}
        value={formatDate(date)}
        placeholder={placeholder}
        onChange={() => {}}
        onBlur={(e) => {
          setClicked(true);
          onBlur(e);
        }}
        hasTitle
        title={title}
        errors={errors}
        containerClassName=""
        readOnly
        customIcon={<CaretDown />}
        customIconPosition="right"
      />
    </Dropdown>
  );
};
